module.exports = __webpack_public_path__ + "media/images/flags/ru-81957a380875b95df452138d39a718e7.svg";